/* eslint-disable no-unused-vars */
import { createAsyncThunk } from "@reduxjs/toolkit";

import { makeRequest } from "../../utilities/api";
import { createFormData } from "../../utilities";

export const getProfile = createAsyncThunk(
  "profile/get",
  async (values, { rejectWithValue }) =>
    makeRequest(
      `/profile${values?.userId ? `?userId=${values.userId}` : ""}`,
      "GET",
      values,
      rejectWithValue
    )
);

export const patchProfile = createAsyncThunk(
  "profile/patch",
  async (values, { rejectWithValue }) => {
    let data = {};

    Object.keys(values).forEach((key) => {
      let value = values[key];

      // skip null / undefined (except address)
      if (value == null && key !== "address") return;

      // skip empty arrays
      if (Array.isArray(value) && value.length === 0) return;

      // skip invalid profile photo
      if (key.includes("profilePhoto") && !(value instanceof File)) return;

      // 🔥 SPECIAL CASE: address → convert null fields to ""
      if (key === "address" && typeof value === "object") {
        value = Object.fromEntries(
          Object.entries(value).map(([k, v]) => [k, v ?? ""])
        );
      }

      data[key] = value;
    });

    if (values?.socialLinks) {
      data.socialLinks = JSON.stringify(values.socialLinks);
    }
    if (values?.skills) {
      data.skills = JSON.stringify(values.skills);
    }
    if (values?.hobbies) {
      data.hobbies = JSON.stringify(values.hobbies);
    }
    if (values?.languages) {
      data.languages = JSON.stringify(values.languages);
    }
    if (values?.education) {
      data.education = JSON.stringify(values.education);
    }
    if (values?.educationLevel) {
      data.educationLevel = JSON.stringify(values.educationLevel);
    }
    if (values?.certificates) {
      data.certificates = JSON.stringify(values.certificates);
    }
    if (values?.workExperience) {
      data.workExperience = JSON.stringify(values.workExperience);
    }

    // final safety cleanup
    data = Object.fromEntries(
      Object.entries(data).filter(([_, v]) => v != null)
    );

    return makeRequest(
      `/profile/${values.id}`,
      "PATCH",
      createFormData(data),
      rejectWithValue
    );
  }
);
